import React, { FC } from 'react';
import styled from 'styled-components';
import { toRem } from './../../ui';
import { Image } from './Image';


type ImageProps = React.ImgHTMLAttributes<HTMLImageElement>;
type IconProps = {
    color?: string,
    size?: string | number,
};

export type Icon = FC<IconProps & ImageProps>;
export const Icon: Icon = (props) => {
    const { color, size, ...other } = props;

    other.style = other.style ?? {};
    if (size) {
        other.style.width = toRem(size);
        other.style.height = toRem(size);
    }
    if (color) {
        other.style.color = color;
    }

    if (!other.src) {
        const NoIconAny = NoIcon as any;
        return <NoIconAny size={size} {...other} />;
    }

    return <Image {...other} />;
};

export const NoIcon = styled.div<{ size?: string | number }>`
    width: ${p => p.size || '1'}rem;
    height: ${p => p.size || '1'}rem;
`;
